import React from 'react';
import { useReactFlow } from '@xyflow/react';
import type { PresenceUser } from '../../hooks/usePresence';

const AVATAR_COLORS = [
  '#3b82f6', '#10b981', '#8b5cf6', '#ec4899',
  '#f59e0b', '#ef4444', '#6366f1', '#14b8a6',
  '#f97316', '#06b6d4',
];

function getUserColor(userId: string): string {
  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    hash = ((hash << 5) - hash) + userId.charCodeAt(i);
    hash |= 0;
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

interface CursorOverlayProps {
  users: PresenceUser[];
}

export function CursorOverlay({ users }: CursorOverlayProps) {
  const { flowToScreenPosition } = useReactFlow();

  const usersWithCursors = users.filter(u => u.cursor != null);

  if (usersWithCursors.length === 0) return null;

  return (
    <div className="absolute inset-0 pointer-events-none z-50 overflow-hidden">
      {usersWithCursors.map(user => {
        const screenPos = flowToScreenPosition({
          x: user.cursor!.x,
          y: user.cursor!.y,
        });
        const color = getUserColor(user.userId);

        return (
          <div
            key={user.userId}
            className="absolute top-0 left-0"
            style={{
              transform: `translate(${screenPos.x}px, ${screenPos.y}px)`,
              transition: 'transform 80ms linear',
            }}
          >
            {/* Cursor arrow SVG */}
            <svg
              width="16"
              height="20"
              viewBox="0 0 16 20"
              fill="none"
              style={{ filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.3))' }}
            >
              <path
                d="M0 0L16 12L8 12L12 20L8 20L4 12L0 16V0Z"
                fill={color}
              />
            </svg>
            {/* Name label */}
            <div
              className="absolute left-4 top-4 px-1.5 py-0.5 rounded text-[10px] font-medium text-white whitespace-nowrap shadow-sm"
              style={{ backgroundColor: color }}
            >
              {user.userName}
            </div>
          </div>
        );
      })}
    </div>
  );
}
